module.exports = __webpack_public_path__ + "img/QQ.ec2fd0bd.png";